import React from 'react';
import { API_URL } from '../config';

// Cache für Share-Settings (wird einmal geladen, dann wiederverwendet)
let cachedSettings = null;
let fetchPromise = null;

const DEFAULTS = {
  video_share_text: 'Mein KI-Video — Erstellt mit SnapshotPro.ai',
  photo_share_text: 'Mein KI-Foto — Erstellt mit SnapshotPro.ai',
};

/**
 * Lädt Share-Settings aus dem Backend (cached).
 */
export async function getShareSettings() {
  if (cachedSettings) return cachedSettings;

  // Dedupliziere parallele Aufrufe
  if (fetchPromise) return fetchPromise;

  fetchPromise = (async () => {
    try {
      const res = await fetch(`${API_URL}/api/referral/bonus-info`);
      if (res.ok) {
        const data = await res.json();
        cachedSettings = {
          video_share_text: data.video_share_text || DEFAULTS.video_share_text,
          photo_share_text: data.photo_share_text || DEFAULTS.photo_share_text,
        };
      } else {
        cachedSettings = { ...DEFAULTS };
      }
    } catch {
      cachedSettings = { ...DEFAULTS };
    }
    fetchPromise = null;
    return cachedSettings;
  })();

  return fetchPromise;
}

/**
 * React Hook: Share-Settings laden
 */
export function useShareSettings() {
  const [settings, setSettings] = React.useState(cachedSettings || DEFAULTS);

  React.useEffect(() => {
    getShareSettings().then(setSettings);
  }, []);

  return settings;
}
